export const mentionsLegalesContent = `# Mentions légales
Dernière mise à jour : juillet 2026

### 1. Éditeur du site
Le site JobVinum, accessible à l'adresse https://jobvinum.io (ou toute autre adresse officielle associée à la plateforme), est édité par :

ETOH SAS
Société par Actions Simplifiée (SAS) au capital de 51 000 €
Siège social : 9 Rue des Colonnes 75002 Paris France
SIREN : 828 397 745
SIRET (siège) : 828 397 745 00062
RCS : Paris
TVA intracommunautaire : FR91828397745
Présidente : Audrey Sousa Chaillet
Email : hello@jobvinum.io

JobVinum est une plateforme éditée par ETOH SAS.

### 2. Hébergement
Le site est hébergé par :

Netlify, Inc.
2325 3rd Street, Suite 296
San Francisco, CA 94107
États-Unis
Site web : https://www.netlify.com

### 3. Propriété intellectuelle
L'ensemble des contenus présents sur le site JobVinum, notamment les textes, marques, logos, photographies, illustrations, bases de données, interfaces, éléments graphiques, logiciels et codes sources, sont protégés par les lois françaises et internationales relatives à la propriété intellectuelle. Sauf mention contraire, ces éléments sont la propriété exclusive d'ETOH SAS. Toute reproduction, représentation, diffusion, modification, adaptation ou exploitation, totale ou partielle, sans autorisation écrite préalable d'ETOH SAS est strictement interdite.

### 4. Protection des données personnelles
Les données personnelles collectées via JobVinum sont traitées conformément au Règlement Général sur la Protection des Données (RGPD) et à la réglementation française applicable. Les données sont utilisées notamment pour :
* créer et gérer les comptes utilisateurs ;
* mettre en relation producteurs et candidats ;
* gérer les candidatures ;
* traiter les paiements ;
* assurer le support utilisateur ;
* améliorer les services proposés ;
* assurer la sécurité de la plateforme.

Les utilisateurs disposent des droits suivants : droit d'accès ; droit de rectification ; droit à l'effacement ; droit à la limitation du traitement ; droit d'opposition ; droit à la portabilité de leurs données. Toute demande peut être adressée à : hello@jobvinum.io

Pour plus d'informations, veuillez consulter notre Politique de confidentialité.

### 5. Nature du service
JobVinum est une plateforme numérique de mise en relation entre employeurs de la filière vitivinicole et candidats. JobVinum n'est ni :
* une agence de travail temporaire ;
* un cabinet de recrutement ;
* un employeur ;
* un organisme de placement.

La plateforme facilite uniquement la mise en relation entre les utilisateurs. Les employeurs demeurent seuls responsables :
* du processus de recrutement ;
* des déclarations administratives ;
* du respect du droit du travail ;
* des obligations sociales et fiscales ;
* de la conformité des contrats conclus avec les candidats.

Les candidats demeurent seuls responsables de l'exactitude des informations et documents transmis. Les éventuelles fonctionnalités futures d'assistance administrative (API TESA, signature électronique, génération de documents, etc.) ont uniquement vocation à faciliter les démarches administratives et ne transfèrent en aucun cas les responsabilités légales des employeurs vers ETOH SAS.

### 6. Responsabilité
ETOH SAS met tout en œuvre afin d'assurer le bon fonctionnement de JobVinum. Toutefois, ETOH SAS ne garantit pas :
* qu'un candidat sera recruté ;
* qu'un producteur trouvera un candidat ;
* la disponibilité permanente du service ;
* l'exactitude ou l'exhaustivité des informations renseignées par les utilisateurs.

Chaque utilisateur est seul responsable :
* des informations publiées ;
* des documents transmis ;
* des échanges réalisés avec les autres utilisateurs ;
* des décisions de recrutement ou de candidature.

ETOH SAS ne saurait être tenue responsable des conséquences résultant des relations établies entre les utilisateurs.

### 7. Disponibilité du service
ETOH SAS s'efforce d'assurer un accès continu à la plateforme. Toutefois, JobVinum peut être temporairement indisponible en raison :
* d'opérations de maintenance ;
* de mises à jour ;
* d'incidents techniques ;
* ou de tout événement indépendant de sa volonté.

Aucune indemnisation ne pourra être réclamée à ce titre.

### 8. Liens externes
Le site peut contenir des liens vers des sites internet ou services tiers. ETOH SAS ne peut être tenue responsable du contenu, du fonctionnement ou de la politique de confidentialité de ces sites.

### 9. Droit applicable
Les présentes mentions légales sont régies par le droit français. Tout litige relatif à leur interprétation ou à leur exécution relève de la compétence exclusive des tribunaux compétents de Paris, sauf disposition légale impérative contraire.

Dernière mise à jour : juillet 2026`;
